import React from "react"
import { ResellerOverviewSection } from "./sections/ResellerOverviewSection"
import { ResellerClientsSection } from "./sections/ResellerClientsSection"
import { ResellerCommissionsSection } from "./sections/ResellerCommissionsSection"
import { ResellerCouponsSection } from "./sections/ResellerCouponsSection"

export type ResellerDashboardSection = "overview" | "clients" | "commissions" | "coupons"

interface ResellerDashboardPageProps {
  section: ResellerDashboardSection
}

export const ResellerDashboardPage: React.FC<ResellerDashboardPageProps> = ({ section }) => {
  if (section === "clients") {
    return <ResellerClientsSection />
  }

  if (section === "commissions") {
    return <ResellerCommissionsSection />
  }

  if (section === "coupons") {
    return <ResellerCouponsSection />
  }

  return <ResellerOverviewSection />
}
